export const template4PlaceholderData = {
  id: 1,
  name: 'Menu 1',
  categories: [
    {
      id: 1,
      name: 'Burgers & Sandwiches',
      items: [
        {
          id: 1,
          itemName: 'Cobb Salad',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
          outOfStock: false,
        },
        {
          id: 2,
          itemName: 'Caesar Salad',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 3,
          itemName: 'Southwest Salad',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 2,
      name: 'Sandwiches',
      items: [
        {
          id: 4,
          itemName: 'Crispy Chicken Sandwich',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 5,
          itemName: 'Spicy Chicken Sandwich',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 6,
          itemName: 'Grilled Chicken Club',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 3,
      name: 'Sides',
      items: [
        {
          id: 7,
          itemName: 'French Fries',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 8,
          itemName: 'Sweet Potato Fries',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 9,
          itemName: 'Onion Rings',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 4,
      name: 'Kids Meals',
      items: [
        {
          id: 10,
          itemName: 'Chicken Nuggets',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 11,
          itemName: 'Kids’ Cheeseburger',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 12,
          itemName: 'Happy Meal',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 5,
      name: 'Wraps',
      items: [
        {
          id: 13,
          itemName: 'Buffalo Chicken Wrap',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 14,
          itemName: 'Turkey Bacon Ranch Wrap',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 15,
          itemName: 'Veggie Wrap',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 6,
      name: 'Breakfast',
      items: [
        {
          id: 16,
          itemName: 'Egg & Cheese Sandwich',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 17,
          itemName: 'Sausage Breakfast Burrito',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 18,
          itemName: 'Pancake Platter',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 7,
      name: 'Pizzas',
      items: [
        {
          id: 19,
          itemName: 'Classic Margherita',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 20,
          itemName: 'Pepperoni Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 21,
          itemName: 'BBQ Chicken Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 8,
      name: 'Pasta',
      items: [
        {
          id: 22,
          itemName: 'Classic Spaghetti & Meatballs',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 23,
          itemName: 'Chicken Alfredo',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 24,
          itemName: 'Penne Primavera',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 9,
      name: 'Desserts',
      items: [
        {
          id: 25,
          itemName: 'Chocolate Chip Cookie',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 26,
          itemName: 'Soft-Serve Sundae',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 27,
          itemName: 'Brownie Bites',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 10,
      name: 'Drinks',
      items: [
        {
          id: 28,
          itemName: 'Fountain Drinks',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 29,
          itemName: 'Milkshakes',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 30,
          itemName: 'Bottled Water',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
  ],
};
